<div>
  <!-- Alert Box -->
  <div class="alert alert-primary" *ngIf="action !== 'update'">
    <div class="d-flex justify-content-between align-items-center">
      <span>Apply discount for all irrespective of region and usage type</span>
      <label class="switch ms-3">
        <input
          type="checkbox"
          [(ngModel)]="selectAll"
          (change)="onSelectAllChange()"
        />
        <span class="slider round"></span>
      </label>
    </div>
  </div>

  <!-- Original Form -->
  <div [ngStyle]="{ display: !selectAll ? 'block' : 'none' }">
    <!-- Region Selection -->
    <div class="mb-4" *ngIf="action !== 'update'">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label fw-bold">Region</label>
        <div class="d-flex gap-3">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="select_all_regions"
              (change)="selectAllRegions($event)"
            />
            <label class="form-check-label" for="select_all_regions"
              >Select All</label
            >
          </div>
          <!-- <span class="nav-link cursor-pointer" *ngIf="regions_reg?.length > 0"
            (click)="selectFiltertedRegions($event)">Select Filtered</span> -->
        </div>
      </div>
      <select
        class="form-control"
        id="regions_reg"
        (change)="fetchPlatformsTypes()"
        [(ngModel)]="ri.regionn"
        data-live-search="true"
        multiple
        required
      >
        <option *ngIf="!regions_reg?.length" disabled>
          Loading regions...
        </option>
        <option *ngFor="let type of regions_reg" [value]="type">
          {{ getDisplayName(type) }}
        </option>
      </select>
    </div>

    <!-- Region (Update) -->
    <div class="mb-4" *ngIf="action == 'update'">
      <label class="form-label fw-bold">Region</label>
      <select
        class="form-control"
        id="regions_reg"
        [(ngModel)]="ri.regionn"
        readonly
      >
        <option [value]="ri?.regionn">{{ ri?.regionn }}</option>
      </select>
    </div>

    <!-- Usage Type Selection -->
    <div class="mb-4" *ngIf="action !== 'update'">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label fw-bold">Usage Type</label>
        <div class="d-flex gap-3">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="select_all_usage_types"
              (change)="selectAllUsageTypes($event)"
            />
            <label class="form-check-label" for="select_all_usage_types"
              >Select All</label
            >
          </div>
          <!-- <span class="nav-link cursor-pointer" *ngIf="usageType?.length > 0"
            (click)="selectFiltertedUsageTypes($event)">Select Filtered</span> -->
        </div>
      </div>
      <select
        class="form-control"
        id="platformsList"
        (change)="fetchRICost()"
        [(ngModel)]="ri.usageType"
        data-live-search="true"
        multiple
        required
      >
        <option *ngIf="!usageType?.length" disabled>
          Loading usage types...
        </option>
        <option *ngFor="let platform of usageType" [value]="platform">
          {{ getDisplayName(platform) }}
        </option>
      </select>
    </div>

    <!-- Usage Type (Update) -->
    <div class="mb-4" *ngIf="action == 'update'">
      <label class="form-label fw-bold">Usage Type</label>
      <select
        class="form-control"
        id="platformsList"
        [(ngModel)]="ri.usageType"
        readonly
      >
        <option [value]="ri?.usageType">
          {{ getDisplayName(ri?.usageType) }}
        </option>
      </select>
    </div>

    <!-- Unit and Price Per Unit -->
    <div
      class="mb-4"
      *ngIf="
        !selectAll &&
        ri?.regionn?.length <= 1 &&
        ri?.usageType?.length <= 1 &&
        ri?.usageType !== 'alls'
      "
    >
      <label class="form-label fw-bold">Unit</label>
      <input type="text" class="form-control" [(ngModel)]="ri.unit" readonly />
    </div>

    <div
      class="mb-4"
      *ngIf="
        !selectAll &&
        ri?.regionn?.length <= 1 &&
        ri?.usageType?.length <= 1 &&
        ri?.usageType !== 'alls'
      "
    >
      <label class="form-label fw-bold">Price Per Unit</label>
      <input type="text" class="form-control" [(ngModel)]="ri.ppu" readonly />
    </div>

    <!-- Discount Type Selection -->
    <div class="mb-4" *ngIf="action !== 'update'">
      <label class="form-label fw-bold d-block mb-2">Discount Type</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="discountType"
          id="percentage"
          value="percentage"
          [(ngModel)]="ri.discountType"
          checked
        />
        <label class="form-check-label" for="percentage">Percentage</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="discountType"
          id="value"
          value="value"
          [(ngModel)]="ri.discountType"
        />
        <label class="form-check-label" for="value">Value</label>
      </div>
    </div>

    <!-- Discount Value or Percentage -->
    <div class="mb-4" *ngIf="action !== 'update'">
      <label class="form-label fw-bold">
        {{
          ri?.discountType == "value" && !selectAll
            ? "Discount Value:"
            : "Discount Percentage:"
        }}
      </label>
      <div class="input-group" style="max-width: 200px">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="ri.discountPercentage"
          required
          (keydown)="validateNumericInput($event)"
        />
        <span class="input-group-text" *ngIf="ri?.discountType !== 'value'"
          >%</span
        >
      </div>
    </div>

    <div class="mb-4" *ngIf="action == 'update'">
      <label class="form-label fw-bold">
        {{
          ri?.discountType == "value" && !selectAll
            ? "Discount Value:"
            : "Discount Percentage:"
        }}
      </label>
      <div class="input-group" style="max-width: 200px">
        <input type="text" class="form-control" [(ngModel)]="disc" required />
        <span
          class="input-group-text"
          *ngIf="ri?.discountType === 'percentage' && !selectAll"
          >%</span
        >
      </div>
    </div>

    <div class="row">
      <label>Period:</label>
      <input
        type="text"
        id="dataRangePicker"
        [(ngModel)]="dateRange"
        class="form-control"
        style="width: 300px"
        placeholder="Select date"
        [disabled]="action == 'update'"
      />
    </div>

    <!-- Alternative Form (Select All) -->
    <div [ngStyle]="{ display: selectAll ? 'block' : 'none' }">
      <!-- Usage Type -->
      <div class="mb-4">
        <label class="form-label fw-bold">Usage Type</label>
        <input
          type="text"
          class="form-control"
          [ngModel]="selectAll ? 'All' : ri?.usageType"
          [disabled]="selectAll"
        />
      </div>

      <!-- Discount Type (Always Percentage) -->
      <div class="mb-4">
        <label class="form-label fw-bold d-block mb-2">Discount Type</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="newDiscountType"
            id="newPercentage"
            value="percentage"
            checked
            disabled
          />
          <label class="form-check-label" for="newPercentage">Percentage</label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="newDiscountType"
            id="newValue"
            value="value"
            disabled
          />
          <label class="form-check-label" for="newValue">Value</label>
        </div>
      </div>

      <!-- Discount Percentage -->
      <div class="mb-4" *ngIf="action !== 'update'">
        <label class="form-label fw-bold">Discount Percentage:</label>
        <div class="input-group" style="max-width: 200px">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="ri.discountPercentage"
            required
          />
          <span class="input-group-text" *ngIf="ri?.discountType !== 'value'"
            >%</span
          >
        </div>
      </div>

      <div class="mb-4" *ngIf="ri?.usageType === 'all' && action == 'update'">
        <label class="form-label fw-bold">Discount Percentage:</label>
        <div class="input-group" style="max-width: 200px">
          <input type="text" class="form-control" [(ngModel)]="disc" required />
          <span class="input-group-text" *ngIf="ri?.discountType !== 'value'"
            >%</span
          >
        </div>
      </div>

      <!-- Period -->
      <div class="mb-4" *ngIf="action !== 'update'">
        <label class="form-label fw-bold">Period:</label>
        <input
          type="text"
          id="dataRangePicker"
          [(ngModel)]="dateRange"
          class="form-control"
          style="width: 300px"
          placeholder="Select date"
        />
      </div>

      <div class="mb-4" *ngIf="action === 'update' && ri?.usageType === 'all'">
        <label class="form-label fw-bold">Period:</label>
        <input
          type="text"
          id="dataRangePicker"
          [(ngModel)]="dateRange"
          class="form-control"
          style="width: 300px"
          placeholder="Select date"
          disabled
        />
      </div>
    </div>

    <style>
      .form-label {
        margin-bottom: 0.5rem;
      }

      .input-group {
        margin-bottom: 1rem;
      }

      .form-check {
        margin-bottom: 0.5rem;
      }

      .cursor-pointer {
        cursor: pointer;
      }

      .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
      }

      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        transition: 0.4s;
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: 0.4s;
        border-radius: 50%;
      }

      input:checked + .slider {
        background-color: #2196f3;
      }

      input:checked + .slider:before {
        transform: translateX(26px);
      }
    </style>
  </div>
</div>
